<div class="grid grid-cols-12">
  <div
    class="col-span-12 bg-gray-200 p-6"
    [ngClass]="{
      'md:col-span-8': showOptions
    }">
    <div
      *ngIf="results; else noResults"
      class="rounded-border overflow-hidden bg-white"
      [ngClass]="{
        'pr-0': showOptions
      }">
      <div
        id="map"
        leaflet
        class="z-0"
        [leafletOptions]="options"
        [leafletMarkerCluster]="markerClusterData"
        [leafletMarkerClusterOptions]="markerClusterOptions"
        (leafletMapReady)="onMapReady($event)"></div>
    </div>
  </div>
  <div *ngIf="showOptions" class="col-span-12 flex flex-col gap-6 p-6 md:col-span-4">
    <div class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="coordinatesColumn">{{
        'search.map.coordinateField.label' | translate
      }}</label>
      <p-select
        id="coordinatesColumn"
        appendTo="body"
        optionLabel="label"
        [options]="mapOptions?.coordinatesColumnOptions"
        [ngModel]="currentMapOptions?.coordinatesColumn"
        [style]="{ width: '100%' }"
        (onChange)="changeMapOptions('coordinatesColumn', $event.value, true)"></p-select>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="startCoordinates">{{
        'search.map.startCoordinates.label' | translate
      }}</label>
      <div class="flex gap-1">
        <button
          pButton
          class="p-button-outlined w-full"
          [icon]="'fa-regular fa-location-crosshairs'"
          [label]="'search.map.startCoordinates.button' | translate"
          [disabled]="!results"
          (click)="handleSelectCurrentLocation()"></button>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="startCoordinates">{{ 'search.map.zoomLevel.label' | translate }}</label>
      <div class="flex">
        <button
          pButton
          class="p-button-outlined w-full"
          [icon]="'fa-regular fa-rotate-reverse'"
          [label]="'search.map.zoomLevel.button' | translate"
          [disabled]="!results"
          (click)="handleResetZoomLevel()"></button>
      </div>
    </div>
  </div>
</div>

<ng-template #noResults>
  <app-empty-state [message]="'general.no.results.found' | translate"></app-empty-state>
</ng-template>
